/**
 * @typedef {Player~parameters} HTMLPlayer~parameters
 * @property jsRoot
 * @property htmlClassName
 */

/**
 * @type {Player}
 */
var HTMLPlayer = function () {

    function include(file, onLoad, onError) {
        var script = document.createElement('script');
        script.src = file;
        script.async = false;
        script.crossOrigin = 'anonymous';
        script.onload = onLoad;
        if (onError) {
            script.onerror = function (error) {
                onError({message: 'Failed to load ' + file + ' (' + error + ')'})
            };
        }
        document.head.appendChild(script);
    }

    /**
     * @param {HTMLPlayer~parameters} parameters
     * @param flashVars
     * @param {Player~onEmbed} onEmbedCallback
     */
    function embed(parameters, flashVars, onEmbedCallback) {
        var release = !__BUILD_DEBUG__;
        var basePath = parameters.jsRoot;
        var name = parameters.htmlClassName;

        var libs = release ? ['howler.min.js', 'pako.min.js', 'lzma.min.js'] : ['howler.js', 'pako.js', 'lzma.js'];
        libs.forEach(function (libraryName) {
            include(basePath + libraryName)
        });

        var openfl = release ? 'openfl.min.js' : 'openfl.js';
        include(basePath + openfl, function () {
            window['flash'] = window['openfl'];
        });

        function run() {
            var GameClass = window[name];
            if (!GameClass) {
                onEmbedCallback({message: name + ' class is not found'}, null);
            } else {
                new GameClass(flashVars, function (error, element) {
                    if (error) {
                        onEmbedCallback({message: '' + error}, null);
                    } else {
                        onEmbedCallback(null, element);
                    }
                });
            }
        }

        include(basePath + name + ".js", run, onEmbedCallback);
    }

    return {
        name: 'HTMLPlayer',
        embed: embed
    }

}();
